export default __webpack_public_path__ + "static/performance-of-graphql-stacks-4c41284b4049913449f4ab747ffcfb01.svg";